import styled from "styled-components";

const Tabela = styled.table`
    width: 100%;
    min-width: 500px; /* Ajuste conforme necessário */
    border-collapse: collapse;
    color: var(--ctrl-text, #333);
    
    thead {
        background-color: var(--ctrl-thead, #f0f0f0);
        position: sticky;
        top: 0;
        z-index: 1;
        
        th {
            text-align: left;
            padding-left: 12px;
            padding-right: 5px;
            font-weight: bold;
            white-space: nowrap;
            height: 40px;
            border-bottom: 1px solid var(--ctrl-border, #ccc);
            color: var(--ctrl-text, #333);
        }
        
        th:last-child {
            padding-right: 15px;
        }
        
        box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
    }
    
    tbody {
        tr {
            height: 35px;
            border-bottom: 1px solid var(--ctrl-border-soft, #e1e1e1);
            
            &:nth-child(even) {
                background-color: var(--ctrl-row-even, #f9f9f9);
            }
            
            &:nth-child(odd) {
                background-color: var(--ctrl-row-odd, #ffffff);
            }
            
            &:last-child {
                border-bottom: none;
            }
            
            &:hover {
                background-color: var(--ctrl-row-hover, #e8f0fe);
            }
            
            td {
                padding-left: 12px;
                padding-right: 10px;
                white-space: nowrap;
                color: var(--ctrl-text, #333);
            }
        }
    }
`

const DataTable = ({ children }) => {
    return (
        <Tabela>{children}</Tabela>
    )
}

export default DataTable;